import React, { useState, useEffect, useMemo, useRef } from "react";

import Card from "../../components/Card";
import { useNavigate } from "react-router-dom";
import { Row, Col, OverlayTrigger, Tooltip, Button, Form, Dropdown } from 'react-bootstrap'
import DashboardService from "../../services/pbumku/DashboardService";
import { Pagination } from "react-bootstrap";
import TabelRekap from "./components/TabelRekap";

const ReportPBUMKU = () => {
  let RepService = useMemo(() => new DashboardService(), []);
  const [reports, setReports] = useState([]);
  const [rekapByPropinsi, setRekapByPropinsi] = useState([]);
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalData, setTotaldata] = useState(1);

  // Ref untuk scroll
  const rincianRef = useRef(null);
  const topRef = useRef(null);

  // Range Tannggal Default
  const today = new Date();
  const year = today.getFullYear();
  const [startOfMonth, setStartOfMonth] = useState(new Date(year, 0, 1));
  const [endOfMonth, setEndOfMonth] = useState(today);

  const formatDate = (date, isEndOfDay = false) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
    const dd = String(date.getDate()).padStart(2, '0');
    const time = isEndOfDay ? '23:59:59' : '00:00:00';
    return `${yyyy}-${mm}-${dd} ${time}`;
  };

  const formatDateInput = (date) => {
    const offset = date.getTimezoneOffset(); // dalam menit
    const localDate = new Date(date.getTime() - offset * 60 * 1000);
    return localDate.toISOString().slice(0, 10);
  };

  // alias header
  const headerAliases = {
    tanggal_aju: "tgl aju",
    tanggal_berangkat: "tgl brkt",
    tanggal_smkhp: "tgl smkhp",
    nomor_aju: "no aju",
    no_hc: "no smkhp",
    nama_upt: "upt",
    nama_trader: "trader",
    alamat_trader: "alamat trader",
    nama_upi: "upi",
    alamat_upi: "alamat upi",
    nama_partner: "partner",
    alamat_partner: "alamat partner",
    pel_asal: "pel asal",
    pel_muat: "pel muat",
    pel_bongkar: "pel bongkar",
    negara_tujuan: "negara",
    kel_ikan: "kel ikan",
    nm_dagang: "nm dagang",
    nm_latin: "nm latin",
    nilai_rupiah: "rp",
    nilai_dolar: "usd",
    kurs_usd: "kurs",
    cara_angkut: "angkut",
    alat_angkut: "alat",
    voyage: "voyage",
  };

  // Variabel untuk baca tanggal default
  // const [selectedBulan, setSelectedBulan] = useState(today.toLocaleString("id-ID", { month: "long" }) + " " + today.toLocaleString("default", { year: "numeric" }));
  const [selectedBulan, setSelectedBulan] = useState(today.toLocaleString("id-ID", { month: "long" }));
  const [selectedTahun, setSelectedTahun] = useState(today.toLocaleString("default", { year: "numeric" }));

  // varibel untuk label bulan tahun
  const [bulanTahun, setBulanTahun] = useState([]);

  // variabel baca upt
  const [kdUPT, setKdUPT] = useState(localStorage.getItem("kdUnit"));

  // limit per page
  const [limit, setLimit] = useState(20); // jumlah data per halaman

  // nama UPT
  const [namaUPT, setNamaUPT] = useState(null);

  // check yang login, dari upt atau dari pusat
  const [isVisibleUpt, setIsVisibleUpt] = useState(false);

  // DefaULT Range Periode
  const [rangePeriode, setRangePeriode] = useState(`Tahun ${selectedTahun}`);


  // template startDate dan endDate
  const [tempStartDate, setTempStartDate] = useState(formatDateInput(startOfMonth));
  const [tempEndDate, setTempEndDate] = useState(formatDateInput(endOfMonth));

  const [tahuns, setTahuns] = useState([]);

  // variabel click export to excell
  const [isDownloading, setIsDownloading] = useState(false);

  // Filet
  const [filterKodeIzin, setFilterKodeIzin] = useState(null);
  const [filterKodeDaerah, setFilterKodeDaerah] = useState(null);
  const [filterText, setFilterText] = useState('');


  useEffect(() => {
    getReports(currentPage, limit, filterKodeIzin, filterKodeDaerah);
    getRekapPropinsi();
    getNamaUPT();
    getTahun();
  }, [limit, currentPage, startOfMonth, endOfMonth, filterKodeIzin, filterKodeDaerah]);


  useEffect(() => {
    let roleUser = localStorage.getItem('role')
    if (roleUser !== "1" && roleUser !== "2" && roleUser !== "3" && roleUser !== "7") {
      navigate('/dashboard')
    }
  }, [navigate]);

  const getReports = async (page, limit, kd_izin = null, kd_daerah_prefix = null) => {
    try {
      const response = await RepService.getReportPBUMKU(
        formatDate(startOfMonth),
        formatDate(endOfMonth, true),
        page,
        limit,
        kd_izin,
        kd_daerah_prefix
      );
      setReports(response.data.data);
      setCurrentPage(response.data.currentPage);
      setTotalPages(response.data.totalPages);
      setTotaldata(response.data.totalData);
    } catch (error) {
      console.error("Gagal mengambil report:", error);
    }
  };

  const getRekapPropinsi = async () => {
    try {
      const response = await RepService.getRekapPrimerPropinsi(
        formatDate(startOfMonth),
        formatDate(endOfMonth, true)
      );
      setRekapByPropinsi(response.data);
    } catch (error) {
      console.error("Gagal mengambil rekap propinsi:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    getReports(pageNumber);
  };

  // Nama UPT
  const getNamaUPT = async () => {
    const cleanedKdUPT = kdUPT.trim();
    const excludedUPTs = new Set(['00.1', '00.2', '00.3']);
    const isExcluded = excludedUPTs.has(cleanedKdUPT);

    if (!isExcluded) {
      try {
        const response = await RepService.getNamaUPT(cleanedKdUPT);
        setNamaUPT(response.data.NM_PENDEK);
        setIsVisibleUpt(true);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const renderPagination = () => {
    const paginationItems = [];
    const maxPagesToShow = 5;
    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(totalPages, currentPage + 2);

    if (currentPage <= 3) {
      endPage = Math.min(totalPages, maxPagesToShow);
    }

    if (currentPage > totalPages - 3) {
      startPage = Math.max(1, totalPages - maxPagesToShow + 1);
    }

    // << Prev
    paginationItems.push(
      <Pagination.Prev
        key="prev"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
      />
    );

    // First page
    if (startPage > 1) {
      paginationItems.push(
        <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    // Middle pages
    for (let number = startPage; number <= endPage; number++) {
      paginationItems.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => handlePageChange(number)}
        >
          {number}
        </Pagination.Item>
      );
    }

    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
      paginationItems.push(
        <Pagination.Item key={totalPages} onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    // Next >>
    paginationItems.push(
      <Pagination.Next
        key="next"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      />
    );

    return paginationItems;
  };

  // Format Tanggal Indonesia
  const formatTanggalIndonesia = (tanggalStr) => {
    const bulanIndo = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember"
    ];

    const tanggal = new Date(tanggalStr);
    const hari = String(tanggal.getDate()).padStart(2, '0');
    const bulan = bulanIndo[tanggal.getMonth()];
    const tahun = tanggal.getFullYear();

    return `${hari} ${bulan} ${tahun}`;
  };

  const handleClickButton = () => {
    if (!tempStartDate || !tempEndDate) {
      alert("Harap isi kedua tanggal.");
      return;
    }

    const tglAwal = new Date(tempStartDate);
    const tglAkhir = new Date(tempEndDate);

    // Validasi akhir >= awal
    if (tglAkhir < tglAwal) {
      alert("Tanggal akhir harus lebih besar atau sama dengan tanggal awal.");
      return;
    }

    // Validasi tahun sama
    if (tglAwal.getFullYear() !== tglAkhir.getFullYear()) {
      alert("Periode harus dalam tahun yang sama.");
      return;
    }

    // ✅ Baru ubah state utama → trigger useEffect
    setStartOfMonth(tglAwal);
    setEndOfMonth(tglAkhir);
    setRangePeriode(
      `${formatTanggalIndonesia(tglAwal)} s/d ${formatTanggalIndonesia(tglAkhir)}`
    );
  };

  const getTahun = async () => {
    const response = await RepService.getTahun()
    setTahuns(response.data)
  };

  const handleDetailClick = (kd_izin, kode_propinsi) => {
    setFilterKodeIzin(kd_izin); // bisa null jika ingin lihat semua
    setFilterKodeDaerah(kode_propinsi); // misalnya '31' untuk DKI
    setCurrentPage(1); // reset ke halaman 1 setiap klik filter baru
    setTimeout(() => {
      rincianRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100); 
  };

  if (!Array.isArray(rekapByPropinsi) || rekapByPropinsi.length === 0) {
    return <p className="text-muted">Data belum tersedia.</p>;
  }

  const half = Math.ceil(rekapByPropinsi.length / 2);
  const firstHalf = rekapByPropinsi.slice(0, half);
  const secondHalf = rekapByPropinsi.slice(half);

  return (
    <>
      <Row ref={topRef} style={{ position: 'relative', top: '-20px' }}>
        {/* Header */}
        <Col md="12">
          <div className="iq-navbar-header mb-4">
            <Row className="align-items-center">
              {/* Kiri: Judul dan Info */}
              <Col lg={8} md={12} className="mb-3 mb-lg-0">
                <h1 className="text-white">Sertifikasi Mutu Primer</h1>
                <h2 className="text-white mb-0">BPPMHKP</h2>
                <h3 className="text-light mt-0">
                  {rangePeriode}
                </h3>
              </Col>

              {/* Kanan: Form dan Dropdown */}
              <Col lg={4} md={12}>
                <Form.Group className="form-group mb-3">
                  <Form.Label htmlFor="exampleInputdate" className="text-white">
                    Periode
                  </Form.Label>
                  <div className="d-flex gap-2 flex-nowrap">
                    <Form.Control
                      type="date"
                      id="tanggalAwal"
                      value={tempStartDate}
                      onChange={(e) => setTempStartDate(e.target.value)}
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #ccc',
                        minWidth: '140px',
                        color: 'white',
                      }}
                    />
                    <Form.Control
                      type="date"
                      id="tanggalAkhir"
                      value={tempEndDate}
                      onChange={(e) => setTempEndDate(e.target.value)}
                      style={{
                        backgroundColor: 'transparent',
                        border: '1px solid #ccc',
                        minWidth: '140px',
                        color: 'white',
                      }}
                    />
                    <Button type="button" variant="primary" className="whitespace-nowrap" onClick={handleClickButton}>
                      Terapkan
                    </Button>
                  </div>
                </Form.Group>
                <div className="d-flex gap-3 flex-wrap">
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row className="mb-3 mt-3">
        <Col md={12}>
          <Card className="h-100 d-flex flex-column">
            <Card.Header>
              <h5 className="card-title mb-0">Rekap Sertifikat Mutu Primer Per Provinsi</h5>
            </Card.Header>
            <Card.Body className="flex-grow-1">
              <Row>
                <Col md={6}>
                  <TabelRekap
                    data={firstHalf}
                    startIndex={1}
                    handleDetailClick={handleDetailClick}
                    setFilterText={setFilterText}
                  />
                </Col>
                <Col md={6}>
                  <TabelRekap
                    data={secondHalf}
                    startIndex={21}
                    handleDetailClick={handleDetailClick}
                    setFilterText={setFilterText}
                  />
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Tabel */}
      <Row ref={rincianRef}>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <div className="header-title">
                <h4 className="card-title mb-0">Rincian Report {filterText}</h4>
              </div>
              <div className="d-flex">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => {
                    setFilterKodeIzin(null);
                    setFilterKodeDaerah(null);
                    setCurrentPage(1);
                    setFilterText('');
                  }}
                >
                  Reset Filter
                </Button>

                <Button
                  variant="outline-primary"
                  size="sm"
                  className="ms-2"
                  onClick={() => {
                    topRef.current?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  Kembali ke Atas
                </Button>
              </div>
            </Card.Header>

            <Card.Body>
              <div className="table-responsive table-responsive-custom">
                <table className="table table-sm table-hover table-bordered table-striped align-middle small">
                  <thead className="table-light">
                    <tr>
                      <th className="px-3 py-2">#</th>
                      <th className="px-3 py-2 text-nowrap text-uppercase">URAIAN PROPINSI</th>
                      {reports[0] &&
                        Object.keys(reports[0])
                          .filter(key =>
                            !["idchecklist", "sts_aktif", "status_checklist", "kd_daerah", "uraian_propinsi"].includes(key)
                          )
                          .map((key, i) => (
                            <th key={i} className="px-3 py-2 text-nowrap text-uppercase">
                              {(headerAliases[key] || key.replace(/_/g, " ")).toUpperCase()}
                            </th>
                          ))}
                    </tr>
                  </thead>
                  <tbody>
                    {reports.map((report, index) => (
                      <tr key={index}>
                        <td className="px-3 py-2">{(currentPage - 1) * limit + index + 1}</td>
                        <td className="px-3 py-2 text-nowrap">{report.uraian_propinsi || "-"}</td>
                        {Object.entries(report)
                          .filter(([key]) =>
                            !["idchecklist", "sts_aktif", "status_checklist", "kd_daerah", "uraian_propinsi"].includes(key)
                          )
                          .map(([_, value], i) => (
                            <td key={i} className="px-3 py-2 text-nowrap">
                              {value || "-"}
                            </td>
                          ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row className="mt-3 align-items-center">
        <Col md="6" className="d-flex justify-content-center justify-content-md-start mb-2 mb-md-0">
          <Pagination>{renderPagination()}</Pagination>
        </Col>
        <Col md="6" className="d-flex align-items-center gap-2 justify-content-center justify-content-md-end">
          <label className="form-label mb-0 text-nowrap">Baris per halaman:</label>
          <select
            className="form-select form-select-sm w-auto"
            value={limit}
            onChange={(e) => {
              setLimit(parseInt(e.target.value));
              setCurrentPage(1);
            }}
          >
            {[15, 20, 50, 100].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </Col>
      </Row>
    </>
  );
};

export default ReportPBUMKU;
